export const sidebarRoutes: { [route: string]: string } = {
  "/m2c-analytics-statistics": "1",
  "/cases": "2",
  "/emails": "3",
  "/launch-dashboard": "4",
  "/m2c-launch-stats": "5",
  "/m2c-launch-history": "6",
  "/athletics-dashboard": "7",
  "/m2c-athletics-stats": "8",
  "/m2c-athletics-history": "9",
  "/simulation-dashboard": "13",
  "/simulation-history": "14",
  "/internal-dashboard": "15",
  "/m2c-analytics": "16",
};

export const sideBarRoutesObjectBasedOnKeys: {
  [key: string]: { [route: string]: string };
} = {
  1: {
    baseRoute: "/cases",
    sourceDashboard: "m2c",
  },
  2: {
    baseRoute: "/cases",
    sourceDashboard: "m2c",
  },
  3: {
    baseRoute: "/emails",
    sourceDashboard: "m2c",
  },
  4: {
    baseRoute: "/launch-dashboard",
    sourceDashboard: "launch",
  },
  5: {
    baseRoute: "/m2c-launch-stats",
    sourceDashboard: "launch",
  },
  6: {
    baseRoute: "/m2c-launch-history",
    sourceDashboard: "launch",
  },
  7: {
    baseRoute: "/athletics-dashboard",
    sourceDashboard: "athletics",
  },
  8: {
    baseRoute: "/m2c-athletics-stats",
    sourceDashboard: "athletics",
  },
  9: {
    baseRoute: "/m2c-athletics-history",
    sourceDashboard: "athletics",
  },
  10: {
    baseRoute: "/m2c-sandbox-dashboard",
    sourceDashboard: "sandbox",
  },
  11: {
    baseRoute: "/m2c-sandbox-stats",
    sourceDashboard: "sandbox",
  },
  12: {
    baseRoute: "/m2c-sandbox-history",
    sourceDashboard: "sandbox",
  },

  13: {
    baseRoute: "/simulation-dashboard",
    sourceDashboard: "simulation",
  },
  14: {
    baseRoute: "/simulation-history",
    sourceDashboard: "simulation",
  },
  15: {
    baseRoute: "/internal-dashboard",
    sourceDashboard: "analytics",
  },
  16: {
    baseRoute: "/m2c-analytics",
    sourceDashboard: "analytics",
  },
  17: {
    baseRoute: "/tonal-dashboard",
    sourceDashboard: "dashboard",
  },
  18: {
    baseRoute: "/tonal-history",
    sourceDashboard: "simulation",
  },

  20: {
    baseRoute: "/m2c-analytics-tickets",
    sourceDashboard: "analytics",
  },
};
